import { Component, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WORK_ITEMS_QA_REPORT_CONFIRMATION_DATA } from './work-items-qa-report-confirmation.modal';

@Component({
  templateUrl: './work-items-qa-report-confirmation.component.html',
  styleUrls: ['./work-items-qa-report-confirmation.component.scss'],
  imports: []
})
export class WorkItemsQaReportConfirmationComponent implements OnInit {
  private readonly activeModal = inject(NgbActiveModal);
  protected readonly inputData = inject(WORK_ITEMS_QA_REPORT_CONFIRMATION_DATA);

  ngOnInit(): void {
    setTimeout(() => this.close(), 6000);
  }

  close(): void {
    this.activeModal.close();
  }
}
